// DS: i3.47
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ManageImages: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12.75 1.25a.85.85 0 0 0-1.2 0l-4 4a.85.85 0 0 0-.25.6v2c0 .47.38.85.85.85h2c.23 0 .44-.09.6-.25l4-4a.85.85 0 0 0 0-1.2zM9 6.2l3.15-3.15.8.8L9.8 7H9z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M4 3.15c0-.47.38-.85.85-.85h1.9a.85.85 0 0 1 0 1.7H5.7v6.3H12V9.29a.85.85 0 0 1 1.7 0v1.86c0 .47-.38.85-.85.85h-8a.85.85 0 0 1-.85-.85z"
        />
        <path
          fill="currentColor"
          d="M1.85 5.3c.47 0 .85.38.85.85v7.15h7.15a.85.85 0 0 1 0 1.7h-8a.85.85 0 0 1-.85-.85v-8c0-.47.38-.85.85-.85"
        />
      </svg>
    </IconWrap>
  );
};
ManageImages.displayName = 'ManageImages';

export default ManageImages;
